import b from 'b_';
import cx from 'classnames';
import React from 'react';

import { UI_KIT_TEXT_TYPOGRAPHY } from '../constants';
import Text from '../text/text';

import './criteria-circle.scss';

interface Props {
    mix?: string;
    max: number;
    correct: number;
    incorrect: number;
    size?: number;
    strokeWidth?: number;
    showTitle?: boolean;
    /**
     * разрыв между участками
     */
    gapPercent?: number;
    isRound?: boolean;
    dark?: boolean;
}

const MAX_PERCENT = 100;

// TODO вынести общее со StatsCircle в отдельный компонент
const CriteriaCircleMemo = (props: Props) => {
    const {
        size = 48,
        strokeWidth = 4,
        showTitle = true,
        gapPercent = 5,
        isRound = true,
        max,
        correct,
        dark,
        mix,
    } = props;
    const radius = size / 2 - strokeWidth / 2;
    const perimeter = 2 * Math.PI * radius;
    const sections = (
        [
            ['correct', props.correct],
            ['incorrect', props.incorrect],
            ['track', max - props.correct - props.incorrect],
        ] as const
    ).filter(([, value]) => value > 0);
    const gaps = sections.length > 1 ? sections.length : 0;
    const shortenForGaps = 1 - (gapPercent * gaps) / MAX_PERCENT;
    const roundCompensate = isRound ? (strokeWidth / 2 / perimeter) * 360 : 0;

    let rotateOffset = 0;

    return (
        <div className={cx('criteria-circle', mix)}>
            {showTitle && (
                <div className="criteria-circle__title" style={{ padding: strokeWidth }}>
                    <Text typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphSMedium}>
                        {correct}
                        <div className="criteria-circle__title-separator">/</div>
                        {max}
                    </Text>
                </div>
            )}
            <svg
                className="criteria-circle__shape"
                fill="none"
                height={size}
                style={{ transform: `rotate(${-90 + roundCompensate}deg)` }}
                viewBox={`0 0 ${size} ${size}`}
                width={size}
            >
                {sections.map(([section, value]) => {
                    const fraction = (value / max) * shortenForGaps;
                    const offset = (1 - fraction) * perimeter;
                    const transform = `rotate(${rotateOffset * 360}deg)`;

                    rotateOffset += fraction + gapPercent / MAX_PERCENT;

                    return (
                        <circle
                            className={b('criteria-circle', section, { dark })}
                            cx={size / 2}
                            cy={size / 2}
                            key={section}
                            r={radius}
                            strokeDasharray={perimeter}
                            strokeDashoffset={isNaN(offset) ? undefined : offset}
                            strokeLinecap={isRound ? 'round' : undefined}
                            strokeWidth={strokeWidth}
                            style={{ transform, transformOrigin: 'center' }}
                        />
                    );
                })}
            </svg>
        </div>
    );
};

export const CriteriaCircle = React.memo(CriteriaCircleMemo);
